import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthCognitoService } from './auth-cognito.service';
import { first, from, map } from 'rxjs';

export const authCognitoGuard: CanActivateFn = (route, state) => {
  const authCognitoService = inject(AuthCognitoService);

  return from(authCognitoService.fetchAuthSession()).pipe(
    map((authSession) => {
      if (authSession.tokens) {
        return true;
      } else {
        authCognitoService.signInWithRedirect();
        return false;
      }
    }),
  );
};
